import { useEffect, useState, useCallback } from 'react'

// Tiny History API router. No matching DSL — components inspect `path`
// directly and decide what to render.

export function usePath(): string {
  const [path, setPath] = useState(() =>
    typeof window === 'undefined' ? '/' : window.location.pathname || '/')
  useEffect(() => {
    const onPop = () => setPath(window.location.pathname || '/')
    window.addEventListener('popstate', onPop)
    return () => window.removeEventListener('popstate', onPop)
  }, [])
  return path
}

// useSearch subscribes to the query string (e.g. `?tab=shopping`) separately
// from the pathname. Kept distinct from usePath so the path-matching regexes in
// App.tsx never have to cope with a trailing `?…`.
export function useSearch(): string {
  const [search, setSearch] = useState(() =>
    typeof window === 'undefined' ? '' : window.location.search)
  useEffect(() => {
    const onPop = () => setSearch(window.location.search)
    window.addEventListener('popstate', onPop)
    return () => window.removeEventListener('popstate', onPop)
  }, [])
  return search
}

export function navigate(to: string, opts: { replace?: boolean } = {}) {
  const cur = window.location.pathname + window.location.search
  if (cur === to) return
  if (opts.replace) window.history.replaceState({}, '', to)
  else window.history.pushState({}, '', to)
  window.dispatchEvent(new PopStateEvent('popstate'))
}

export function useNavigate() {
  return useCallback((to: string, opts?: { replace?: boolean }) => navigate(to, opts), [])
}
